<div class="login-background" style="background-color: #e9f5ff;">
  <div class="container">
    <div class="login-title">
      <p class="text-title">{{'auth.login.hero' | translate}}</p>
    </div>
    <div class="login-box card">
      <div class="card-body">
        <form class="form-horizontal form-material" id="loginform" *ngIf="!firstTime && !messageSuccess">
          <img src="assets/images/trobbit-logo.png" alt="trobbit" class="mx-auto d-block trobbit-logo">
          <h4 class="box-title text-center py-4">{{'auth.login.title' | translate}}</h4>
          <div class="text-center">
            <div class="form-group">
              <div class="col-xs-12">
                <div class="text-left mx-5">
                  <small>{{'auth.email' | translate}}</small>
                </div>
                <input [(ngModel)]="email" name="email" class="form-control input-form" type="email" required=""> </div>
            </div>
            <div class="form-group">
              <div class="col-xs-12">
                <div class="text-left mx-5">
                  <small>{{'auth.password' | translate}}</small>
                </div>
                <input [(ngModel)]="password" name="password" class="form-control input-form" type="password" required="">
              </div>
            </div>
            <ngb-alert type="danger" [dismissible]="false" *ngIf="errorMessage">
              <strong>{{'common.error' | translate}}: </strong> {{errorMessage}}.
            </ngb-alert>
            <div class="form-group pt-1">
              <div class="w-100 d-flex justify-content-center">
                <button class="btn btn-info waves-effect waves-light btn-grad" (click)="login()">
                  {{'auth.login.submit' | translate}}
                </button>
              </div>
            </div>
            <div class="form-group mb-2">
              <div class="col-12 text-center">
                  <small class="text-primary" [routerLink]="['/password-recovery']">
                    <u>{{'auth.forgotPasswordLink' | translate}}</u>
                  </small>
              </div>
              <div class="col-12 mt-5 text-center">
                <hr>
                <small>
                  <a class="text-secondary text-footer" href="https://trobbit.com/terminos-y-condiciones" target="_blank">
                    {{'auth.terms' | translate}}</a><span class="pr-1 pl-2">|</span>
                  <a class="text-secondary text-footer" href="https://trobbit.com/politica-privacidad" target="_blank">
                    {{'auth.privacyPolicy' | translate}}</a>
                </small>
              </div>
            </div>
          </div>
        </form>

        <form class="form-horizontal form-material" id="loginform2" *ngIf="firstTime && !messageSuccess">
          <img src="assets/images/trobbit-logo.png" alt="trobbit" class="mx-auto d-block trobbit-logo">
          <h4 class="box-title text-center py-4">{{'auth.login.welcome' | translate}}</h4>
          <div class="text-center">

            <div class="form-group m-b-0">
              <div class="col-sm-12 text-center">
                <div class="text-left mx-5">
                  <small>{{'auth.resetPassword.helpText' | translate}}</small>
                </div>
              </div>
            </div>
            <div class="form-group col-sm-12 text-center">
              <input [(ngModel)]="passwordNew" name="passwordNew" (keyup)="validatePassword()" id="passwordInput" class="form-control input-form" type="password" maxlength="30" required>
              <i id="visibilityIcon" class="fa fa-eye-slash" (click)="changeVisibility()"></i>
              <small class="form-text text-justify text-danger" *ngIf="invalidPassword">{{'admin.settings.users.passwordRequirements' | translate}}</small>
            </div>

            <div class="form-group m-b-0">
              <div class="col-sm-12 text-center">
                <div class="text-left mx-5">
                  <small>{{'auth.resetPassword.helTextRepeat' | translate}}</small>
                </div>
              </div>
            </div>
            <div class="form-group col-sm-12 text-center">
              <input [(ngModel)]="repeatPassword" name="repeatPassword" (keyup)="confirmPassword()" id="verifyPassword" class="form-control input-form" type="password" required>
              <i id="visibilityConfirmIcon" class="fa fa-eye-slash" (click)="changeVisibilityConfirm()"></i>
              <small class="form-text text-danger" *ngIf="passwordsMatch">{{'auth.resetPassword.passwordsDontMatch' | translate}}</small>
            </div>
            <div class="col-sm-12 alert alert-danger" *ngIf="activationValid">
              <p>{{'auth.login.tokenTimeout' | translate}}</p>
            </div>


            <div class="form-group pt-3">
              <div class="w-100 d-flex justify-content-center">
                <button class="btn btn-info waves-effect waves-light btn-grad" [disabled]="passwordsMatch || invalidPassword" (click)="activateUser()">
                  {{'auth.login.submit' | translate}}
                </button>
              </div>
            </div>
          </div>
        </form>

        <form class="form-horizontal form-material" id="loginform3" *ngIf="!firstTime && messageSuccess">
          <img src="assets/images/trobbit-logo.png" alt="trobbit" class="mx-auto d-block trobbit-logo">
          <h4 class="box-title text-center py-4">{{'auth.login.welcome' | translate}}</h4>
          <div class="col-sm-12 text-justify">
            <div>
              <p>{{'auth.login.messageWaiting' | translate}}</p>
              <div class="text-center">
                <mat-spinner style="margin:0 auto;" mode="indeterminate"></mat-spinner>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
